import { useState } from 'react'
import { toast } from 'react-toastify'
import { useAuth } from '../../hooks/useAuth'
import { useNavigate } from 'react-router-dom'

import styles from './login.module.scss'

import { Loader } from '@/components/Loader'

export function LoginInstitution() {
  const { signIn } = useAuth()
  const navigate = useNavigate()
  const [login, setLogin] = useState('')
  const [password, setPassword] = useState('')
  const [loading, setLoading] = useState(false)

  async function handleLogin() {
    try {
      setLoading(true)
      const error = await signIn({ login, password, role: 'institutions' })
      if (error) {
        toast.error('Erro ao entrar, verifique suas credenciais.')
        return
      }
      navigate('/perfil')
    } catch (error) {
      toast.error('Erro ao entrar, verifique suas credenciais.')
    } finally {
      setLoading(false)
    }
  }

  return (
    <div className={styles.background}>
      {loading && <Loader />}
      <div className={styles.backgroundTwo}>
        <div className={styles.column}>
          <img src="/logo/posso.png" />
          <div className={styles.text2}>
            <p>Entrar - Instituição</p>
          </div>
          <div className={styles.text}>
            <p>Email da instituição</p>
          </div>
          <input
            value={login}
            onChange={(e) => setLogin(e.target.value)}
            placeholder="Email..."
          />
          <div className={styles.text}>
            <p>Senha</p>
          </div>
          <input
            value={password}
            onChange={(e) => setPassword(e.target.value)}
            placeholder="Senha..."
          />
          <div className={styles.bar}></div>
          <button onClick={handleLogin}>Entrar</button>
        </div>
        <div className={styles.columnTwo}>
          <img src="/login-illustrator.png" />
        </div>
      </div>
    </div>
  )
}
